<div>
    <div class="table-responsive settings-table-shell settings-reference-table rounded-2 border d-none d-md-block">
        <table
            class="table  table-hover align-middle mb-0 settings-data-table global_data_table text-xs"
            data-search-placeholder="Search properties"
            data-non-orderable-targets="[6]"
            data-page-length="5"
            data-order-column="0"
            data-order-direction="asc"
        >
            <thead>
                <tr>
                    <th scope="col" class="settings-table-head  fw-semibold text-xs">Property</th>
                    <th scope="col" class="settings-table-head  fw-semibold text-xs">Tariff name</th>
                    <th scope="col" class="settings-table-head  fw-semibold text-xs">Tariff book</th>
                    <th scope="col" class="settings-table-head  fw-semibold text-xs">Code</th>
                    <th scope="col" class="settings-table-head  fw-semibold text-xs">Tariff category</th>
                    <th scope="col" class="settings-table-head  fw-semibold text-xs">Effective dates</th>
                    <th scope="col" class="settings-table-head  fw-semibold text-xs text-end">Actions</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="row in tariff_rows" :key="row.id">
                    <td>
                        <span class=" fw-semibold text-xs lh-sm">{{ row.property_name }}</span>
                    </td>
                    <td>
                        <span class=" fw-semibold text-xs">{{ row.has_assignment ? row.tariff_name : "-" }}</span>
                    </td>
                    <td>
                        <span class=" fw-semibold text-xs">{{ row.has_assignment ? row.tariff_book_name : "-" }}</span>
                    </td>
                    <td class=" fw-semibold text-xs">{{ row.has_assignment ? row.tariff_code : "-" }}</td>
                    <td>
                        <span class="badge rounded-pill settings-soft-badge settings-soft-badge-pink text-xs">
                            {{ row.has_assignment ? row.tariff_category : "-" }}
                        </span>
                    </td>
                    <td>
                        <span class=" fw-semibold text-xs lh-sm">
                            {{ row.rate_effective_from || row.effective_from ? get_assignment_date_range(row) : "-" }}
                        </span>
                    </td>
                    <td>
                        <div class="d-flex justify-content-end gap-2 flex-wrap">
                            <button
                                type="button"
                                class="btn-primary rounded-3 d-flex align-items-center gap-1 settings-button-shape settings-action-button"
                                @click="$emit('edit-assignment', row)"
                                :aria-label="row.has_assignment ? 'Unassign tariff' : 'Assign tariff'"
                            >
                                <span class="text-xs">{{ row.has_assignment ? "Unassign" : "Assign" }}</span>
                            </button>
                        </div>
                    </td>
                </tr>

                <tr v-if="!tariff_rows.length">
                    <td colspan="7" class="text-center  py-4 text-xs">
                        <div class="d-flex flex-column align-items-center justify-content-center py-4">
                            <span class="d-inline-flex align-items-center justify-content-center rounded-circle border bg-danger bg-opacity-10 text-danger  mb-3" style="width: 2.5rem; height: 2.5rem;">
                                <i class="bi bi-building"></i>
                            </span>
                            <p class=" fw-semibold mb-1">No properties available</p>
                            <p class=" text-xs mb-0">Properties and assigned tariff books will appear here once loaded.</p>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="d-md-none">
        <SettingsMobileListControls
            v-if="tariff_rows.length"
            class="mb-3"
            :search-value="mobile_search"
            search-placeholder="Search properties"
            :current-page="mobile_page"
            :page-count="mobile_page_count"
            pagination-label="Tariff assignments pages"
            :show-pagination="false"
            @update:search-value="mobile_search = $event"
            @update:current-page="set_mobile_page"
        />

        <div v-if="tariff_rows.length" class="d-flex flex-column gap-3">
            <article
                v-for="row in paginated_mobile_tariff_rows"
                :key="`mobile-${row.id}`"
                class="card bcx-card  border shadow-sm"
            >
                <div class="card-body p-3">
                    <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
                        <div class="min-w-0">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-2">Property</p>
                            <h6 class="fw-semibold mb-1 text-break">{{ row.property_name }}</h6>
                            <p class="text-secondary text-xs mb-0">
                                {{ row.has_assignment ? row.tariff_book_name : "No tariff book assigned" }}
                            </p>
                        </div>

                        <span
                            class="badge rounded-pill text-xs flex-shrink-0"
                            :class="row.has_assignment ? 'bg-success text-dark' : 'bg-secondary'"
                        >
                            {{ row.has_assignment ? "Assigned" : "Unassigned" }}
                        </span>
                    </div>

                    <div class="row g-3">
                        <div class="col-12">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-1">Tariff name</p>
                            <p class="fw-semibold text-xs mb-0">{{ row.has_assignment ? row.tariff_name : "No tariff assigned" }}</p>
                        </div>

                        <div class="col-12">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-1">Tariff book</p>
                            <p class="fw-semibold text-xs mb-0">{{ row.has_assignment ? row.tariff_book_name : "No tariff book assigned" }}</p>
                        </div>

                        <div class="col-6">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-1">Code</p>
                            <p class="fw-semibold text-xs mb-0">{{ row.has_assignment ? row.tariff_code : "-" }}</p>
                        </div>

                        <div class="col-6">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-1">Category</p>
                            <span class="badge rounded-pill bg-primary  text-xs">
                                {{ row.has_assignment ? row.tariff_category : "-" }}
                            </span>
                        </div>

                        <div class="col-12">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-1">Municipality</p>
                            <p class="fw-semibold text-xs mb-0">{{ row.has_assignment ? row.municipality_name || "-" : "-" }}</p>
                        </div>

                        <div class="col-12">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-1">Effective dates</p>
                            <p class="fw-semibold text-xs mb-0">
                                {{ row.rate_effective_from || row.effective_from ? get_assignment_date_range(row) : "-" }}
                            </p>
                        </div>

                        <div class="col-12">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-2">Actions</p>
                            <button
                                type="button"
                                class="btn btn-primary btn-sm rounded-3 d-inline-flex align-items-center gap-2"
                                @click="$emit('edit-assignment', row)"
                                :aria-label="row.has_assignment ? 'Unassign tariff' : 'Assign tariff'"
                            >
                                <i :class="row.has_assignment ? 'bi bi-x-circle' : 'bi bi-plus-circle'"></i>
                                <span class="text-xs">{{ row.has_assignment ? "Unassign" : "Assign" }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </article>

            <div v-if="!paginated_mobile_tariff_rows.length" class="card bcx-card  border">
                <div class="card-body text-center py-4">
                    <p class="text-secondary text-xs mb-0">No matching properties found.</p>
                </div>
            </div>

            <SettingsMobileListControls
                :search-value="mobile_search"
                :current-page="mobile_page"
                :page-count="mobile_page_count"
                pagination-label="Tariff assignments pages"
                :show-search="false"
                @update:current-page="set_mobile_page"
            />
        </div>

        <div v-else class="card bcx-card  border">
            <div class="card-body text-center py-5">
                <span class="d-inline-flex align-items-center justify-content-center rounded-circle border bg-danger bg-opacity-10 text-danger  mb-3" style="width: 2.5rem; height: 2.5rem;">
                    <i class="bi bi-building"></i>
                </span>
                <p class=" fw-semibold mb-1">No properties available</p>
                <p class="text-secondary text-xs mb-0">Properties and assigned tariff books will appear here once loaded.</p>
            </div>
        </div>
    </div>
</div>
